import React from 'react';
import './Auth.css';

function AuthLayout({ children, title, subtitle, illustration }) {
  return (
    <div className="auth-container">
      {/* Left Side - Branding/Illustration */}
      <div className="auth-left">
        <div className="auth-brand">
          <h1>Pi<span>vot</span></h1>
          <p className="auth-tagline">Admin Control</p>
        </div>
        <div className="auth-illustration">
          <div className="auth-illustration-content">
            <i className="ti ti-health" style={{ fontSize: 64, color: 'var(--blue)' }} />
            <h2>Govern Your Clinical Workspace</h2>
            <p>Control user access, metadata standards, and audit visibility for every clinical module.</p>
            <div className="auth-features">
              <div className="auth-feature">
                <i className="ti ti-users" />
                <span>User Access</span>
              </div>
              <div className="auth-feature">
                <i className="ti ti-settings" />
                <span>Metadata Control</span>
              </div>
              <div className="auth-feature">
                <i className="ti ti-lock" />
                <span>Role Governance</span>
              </div>
              <div className="auth-feature">
                <i className="ti ti-history" />
                <span>Audit Oversight</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Side - Form */}
      <div className="auth-right">
        <div className="auth-form-container">
          <div className="auth-form-header">
            <h2>{title}</h2>
            <p className="auth-subtitle">{subtitle}</p>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}

export default AuthLayout;